import { useSyncExternalStore } from "react";

export type EpocusWorkMode = "clinical" | "qa";

const STORAGE_KEY = "epocus.workMode";
const SAME_TAB_EVENT = "epocus.workMode.change";
const DEFAULT_MODE: EpocusWorkMode = "clinical";

let memoryMode: EpocusWorkMode | null = null;

const readWorkMode = (): EpocusWorkMode => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "qa"
      ? "qa"
      : DEFAULT_MODE;
  } catch {
    return DEFAULT_MODE;
  }
};

export const setEpocusWorkMode = (mode: EpocusWorkMode): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
    memoryMode = null;
  } catch {
    memoryMode = mode;
  }
  window.dispatchEvent(new CustomEvent(SAME_TAB_EVENT));
};

const getSnapshot = (): EpocusWorkMode => memoryMode ?? readWorkMode();

const subscribe = (listener: () => void): (() => void) => {
  const handler = (event: Event) => {
    if (event instanceof StorageEvent && event.key !== STORAGE_KEY) return;
    listener();
  };
  window.addEventListener("storage", handler);
  window.addEventListener(SAME_TAB_EVENT, handler);
  return () => {
    window.removeEventListener("storage", handler);
    window.removeEventListener(SAME_TAB_EVENT, handler);
  };
};

export const useEpocusWorkMode = (): EpocusWorkMode =>
  useSyncExternalStore(subscribe, getSnapshot, () => DEFAULT_MODE);
